import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import AddRoom from './AddRoom';
import './styles/heading.css';


function Heading(props) {
    const logout = () => {
        firebase.auth().signOut()
        .then(() => {
            alert("Logout success");
        }).catch((error) => {
            // An error happened.
            alert("Logout error", error.message);
        });
    };

  return (
    <div>
        <Navbar expand="sm" className="bg-body-tertiary" fixed="top" >
        <Container>
            <Navbar.Brand href="#">CHAT ROOM</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <button id="logout" onClick={logout} style={{border: "none"}}>
                        <img src="./img/exit.png" alt="user" />
                    </button>
                    <AddRoom handle_add_room={props.handle_add_room}/>
                </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </div>
  );
}
export default Heading;